import { useEffect, useRef, useState } from 'react';

import { Customer, } from '../../classess/customer/customer';

import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj, getResponse, handleResponseMessageAsync, settings, styles,
    getUserRoles, LoadingSection, awaitDelayAsync, getServiceHtml
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { DocumentService } from '../../classess/CHEJConsultorCA/documentService/documentService';
import { BackupReviewService } from '../../services/backupReviews/BackupReviewService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, timers } = settings;

const currentMethod = 'BackupReviews';

export default function BackupReviews({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    const userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;
    const dtBackupReviewsId = 'dtBackupReviews';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ showLoading: true });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    //#region backupreview
    const getEditDetailsBackupReview = async ({
        e = {},
        id = '',
        description = '',
        type = 0,
        rowId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getEditDetailsBackupReview';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            const urlbackupReviews = {
                edit: `${backend?.urls?.backupReviews}/${labels?.edit?.en?.toLowerCase()}/${id}`,
                details: `${backend?.urls?.backupReviews}/${labels?.details?.en?.toLowerCase()}/${id}`,
            };

            window.location.href = type === 1 ? urlbackupReviews?.edit : urlbackupReviews?.details;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
            }
        }
    }
    //#endregion backupreview

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let customersData = [];
            let backupReviewsData = [DocumentService?.getClass({}, false)];
            //#endregion variables

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (backupreviews)
                response = await BackupReviewService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });

                if (!response?.isSuccess || response?.isWarning) return;

                customersData = response?.result?.customers || [];
                customersData?.sort((a, b) => a.name > b.name ? 1 : -1);
                backupReviewsData = response?.result?.backupReviews || [];
                //#endregion get data (backupreviews)

                //#region set datatable
                if ((!isUndNullEmp({ data: backupReviewsData, subMethod: currentMethod })?.result && backupReviewsData?.length > 0) ||
                    (!isUndNullEmp({ data: customersData, subMethod: currentMethod })?.result && customersData?.length > 0)) {
                    response = setDataInDataTable({
                        data: backupReviewsData,
                        customers: customersData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, setShowData, showDataValue: response?.isSuccess, languageId: languageObj?.id });
            }
        }
    }

    //#region datatable
    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtBackupReviewsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.customer?.[languageObj?.id], width: '85%', },
                    { title: labels?.service?.[languageObj?.id], className: 'text-center', width: '10%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtBackupReviewsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion datatable

    //#region querycode
    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            const tableBody = $(`#${dtBackupReviewsId} tbody`);
            tableBody.off('click', 'tr td');
            tableBody.on('click', 'tr td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtBackupReviewsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';

                    switch (methodName) {
                        case 'edit':
                            getEditDetailsBackupReview({ e, id: id_, description: description, type: 1, rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            getEditDetailsBackupReview({ e, id: id_, description: description, type: 2, rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion querycode

    //#region dataindatatable
    const setDataInDataTable = ({
        data = [],
        customers = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            const rowsDt = customers.map((customer) => {
                const modelCustomer = Customer?.getClass(customer, false);
                const modelBackupReview = data.find(({ docCustomerId }) => docCustomerId === modelCustomer?.secundaryId) || {};

                const isChecked = !isUndNullEmp({ data: modelBackupReview, subMethod: currentMethod })?.result &&
                    modelBackupReview?.docNumber > 0;

                const serviceHtml = getServiceHtml({
                    isChecked: isChecked,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;

                const buttonsHtml = getProcessButtons({
                    id: modelCustomer?.secundaryId,
                    description: modelCustomer?.name,
                    showDetails: true,
                    labelDetails: labels?.details?.[languageObj?.id],
                    enabledDetails: true,
                    showDelete: false,
                    enabledDelete: false,
                    showEdit: (userRoles?.isAdmin || userRoles?.isAnalyst),
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: (userRoles?.isAdmin || userRoles?.isAnalyst),
                    processButtons: [],
                })?.result;

                return [
                    modelCustomer?.name || '',
                    serviceHtml,
                    buttonsHtml,
                ];
            });

            $(`#${dtBackupReviewsId}`).DataTable().rows.add(rowsDt).draw(true);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion dataindatatable

    useEffect(() => {
        isMount.current = true;
        getData();
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.services?.services} process={app?.views?.backupReviews?.backupReviews} />

            <div className='content-wrapper bg-transparent'>
                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.backupReviews?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.backupReviews?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt='backupReviews' style={styles?.cardHeaderLogo} src={images?.icons?.backupReviews} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.backupReviews?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.dataBase} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Maintenance'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtBackupReviewsId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>
            </div>

        </div>
    )
}